import React from 'react';

/**
 * Sticker — kleine ronde Bungee-badge in een pastelvariant met lichte tilt-loop.
 * Geen geld-informatie, alleen tekstuele labels.
 */
export const Sticker = ({ children, variant = 'green', tilt = 'l', className = '', ...rest }) => {
    const variantClass = {
        green: 'zz-sticker zz-sticker--green',
        cream: 'zz-sticker zz-sticker--cream',
        pink: 'zz-sticker zz-sticker--pink',
        yellow: 'zz-sticker zz-sticker--yellow',
        mint: 'zz-sticker zz-sticker--mint',
    }[variant] || 'zz-sticker zz-sticker--green';
    const tiltClass = tilt === 'r' ? 'zz-tilt-r' : 'zz-tilt-l';
    return (
        <span className={`${variantClass} ${tiltClass} ${className}`} {...rest}>
            {children}
        </span>
    );
};

export default Sticker;
